import React from 'react';
import styled from 'styled-components';

const TestimonialContainer = styled.div`
  background-color: var(--white);
  border-radius: var(--border-radius-lg);
  box-shadow: var(--shadow-md);
  padding: var(--spacing-xl);
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '"';
    position: absolute;
    top: var(--spacing-md);
    left: var(--spacing-md);
    font-size: 5rem;
    line-height: 1;
    color: var(--primary-light);
    opacity: 0.2;
    font-family: serif;
  }
`;

const TestimonialQuote = styled.blockquote`
  font-size: var(--font-size-lg);
  line-height: 1.6;
  color: var(--text-primary);
  margin-bottom: var(--spacing-lg);
  position: relative;
  z-index: 1;
`;

const TestimonialFooter = styled.footer`
  display: flex;
  align-items: center;
`;

const TestimonialAvatar = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: var(--spacing-md);
  flex-shrink: 0;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const TestimonialInfo = styled.div`
  flex: 1;
`;

const TestimonialName = styled.h4`
  font-size: var(--font-size-md);
  margin-bottom: var(--spacing-xs);
  color: var(--text-primary);
`;

const TestimonialRole = styled.p`
  font-size: var(--font-size-sm);
  color: var(--text-secondary);
  margin-bottom: var(--spacing-xs);
`;

const TestimonialCompany = styled.p`
  font-size: var(--font-size-sm);
  color: var(--primary);
  font-weight: 500;
`;

const TestimonialStats = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: var(--spacing-md);
  margin-top: var(--spacing-md);
`;

const TestimonialStat = styled.div`
  text-align: center;
`;

const TestimonialStatValue = styled.div`
  font-size: var(--font-size-2xl);
  font-weight: 700;
  color: var(--primary);
`;

const TestimonialStatLabel = styled.div`
  font-size: var(--font-size-sm);
  color: var(--text-secondary);
`;

const Testimonial = ({
  quote,
  name,
  role,
  company,
  avatar,
  stats = []
}) => {
  return (
    <TestimonialContainer>
      <TestimonialQuote>
        {quote}
      </TestimonialQuote>
      
      <TestimonialFooter>
        {avatar && (
          <TestimonialAvatar>
            <img src={avatar} alt={`${name}'s avatar`} />
          </TestimonialAvatar>
        )}
        
        <TestimonialInfo>
          <TestimonialName>{name}</TestimonialName>
          {role && <TestimonialRole>{role}</TestimonialRole>}
          {company && <TestimonialCompany>{company}</TestimonialCompany>}
        </TestimonialInfo>
      </TestimonialFooter>
      
      {stats.length > 0 && (
        <TestimonialStats>
          {stats.map((stat, index) => (
            <TestimonialStat key={index}>
              <TestimonialStatValue>{stat.value}</TestimonialStatValue>
              <TestimonialStatLabel>{stat.label}</TestimonialStatLabel>
            </TestimonialStat>
          ))}
        </TestimonialStats>
      )}
    </TestimonialContainer>
  );
};

export default Testimonial;
